import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import DataTable from 'datatables.net-vue3'
import Toast from "vue-toastification";
import VueLoading from 'vue-loading-overlay';

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL

// import $ from 'jquery'
import '@/assets/scss/mystore.scss';
import 'bootstrap';

// CSS TOAST (Notification)
import "vue-toastification/dist/index.css";

// CSS LOADING
import 'vue-loading-overlay/dist/vue-loading.css';

const optionsToast = {
  position: 'top-center'
}
createApp( App )
  .component( 'DataTable',
    DataTable )
  .use( Toast, optionsToast )
  .use( store )
  .use( router )
  .use( VueLoading, {
    color: 'black',
    'can-cancel': false
  } )
  .mount( '#app' )